import Api from '../api/api';
import {getQueryStringValue, getCookie } from './cookies';
import * as Type from './actionConstants';
import {checkBookingFunctionData} from '../helperFunction/helper';

var VenueList = [];
var EventLists = [];



export function dispatchAction(type, payload){
  return function(dispatch){
    dispatch({ type: type , payload: payload});
  }
}



  function createQueryParam(pageNo, location, sports){
    var query = "page="+pageNo+"&"+"lat="+location[0]+"&"+"lng="+location[1];

    if(sports.length > 0){
      query = query.concat("&sportId=", sports.join(","));
    }
    return query;

  }


  export  function getDeepLinking(link){
     var info = {
      "dynamicLinkInfo": {
        "dynamicLinkDomain": "z34v4.app.goo.gl",
        "link": link,
        "androidInfo": {
          "androidPackageName": "com.techmash.playo"
        },
        "iosInfo": {
          "iosBundleId": "com.techmash.Playo"
        }
      }
    }
    return function (dispatch) {
      dispatch(dispatchAction(Type.SWITCH_LOADER, true));
     return Api.hitDeepLinking(info).then(response =>{
      let parsedResult = JSON.parse(response.text);

          dispatch(dispatchAction(Type.SWITCH_LOADER, false));
          window.location = parsedResult.shortLink;

    }).catch(err =>{
       console.log(err);
        dispatch(dispatchAction(Type.SWITCH_LOADER, false));
    });
   }
  }



  export function fetchOffers(city){

    var param = "lat="+city.lat+"&lng="+city.lng;
    return function (dispatch) {
      dispatch(dispatchAction(Type.SWITCH_LOADER, true));
      return Api.fetchAllOffers(param).then(response =>{
        let parsedResult = JSON.parse(response.text);
        console.log(parsedResult);

        dispatch(dispatchAction(Type.GET_ALL_OFFERS, parsedResult.offers));

        dispatch(dispatchAction(Type.SWITCH_LOADER, false));

      }).catch(err => {
        dispatch(dispatchAction(Type.SWITCH_LOADER, false));
      });
    };
  }






// WEBPACK FOOTER //
// ./src/action/apiCallActions.js